export { Loading, type LoadingProps } from "./Loading.component";
